// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import Dropzone from 'react-dropzone';
import Loading from '../../../../elements/Loading/Loading';

import style from './UploadBox.scss';
import icons from '../../../../assets/styles/icons.scss';

type Props = {
  isLoading?: boolean;
  hasError?: boolean;
  preview?: string;
  fileType?: string;
  hasUploaded?: boolean;
  loadingInl: string;
  uploadIntl: string;
  hintIntl?: string;
  successIntl: string;
  changeImageIntl: string;
  errorIntl?: string;
  retryIntl?: string;
  handleChangeFile: (files: File[]) => void;
  handleRejectedFile: (files: File[]) => void;
};

export const validFormats = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];

export const uploadErrorMessages = {
  format: 'order.uploadBox.error.format',
  size: 'order.uploadBox.error.size',
  default: 'order.uploadBox.error.default',
  required: 'order.uploadBox.error.required',
};

export default class UploadBox extends Component<Props> {
  render() {
    const {
      isLoading, hasError, preview, fileType, hasUploaded, loadingInl, uploadIntl, hintIntl, successIntl,
      changeImageIntl, errorIntl, retryIntl, handleRejectedFile, handleChangeFile,
    } = this.props;
    return (
      <Dropzone accept={validFormats.join()}
                multiple={false}
                disabled={isLoading}
                maxSize={3145728}
                className={classNames(style.dropzone, {
                  [style.error]: hasError,
                  [style.loading]: isLoading,
                  [style.success]: hasUploaded && !isLoading,
                })}
                activeClassName={style.active}
                onDropAccepted={handleChangeFile}
                onDropRejected={handleRejectedFile}>
        <div className={style.uploadWrap}>
          {/*Image*/}
          <div className={style.imageWrap}>
            {!!preview && !hasError && fileType !== 'application/pdf' &&
            <img src={preview} alt="image"
                 className={classNames(style.image, { [style.preview]: !hasUploaded || isLoading })}/>}
            {((!preview && !hasUploaded) || hasError) &&
            <i className={icons.iconPictureMedium}/>}
            {(fileType === 'application/pdf' && !hasError) &&
            <p>PDF</p>}
          </div>
          {/*Ready to upload*/}
          {!isLoading && !hasUploaded && !hasError &&
          <div className={style.middleWrap}>
            <i className={classNames(icons.symbolUpload, style.upload)}/>
            <FormattedMessage id={uploadIntl}>{
              txt => <p className={classNames(style.upload, style.bold)}>{txt}</p>
            }</FormattedMessage>
            <FormattedMessage id={hintIntl}>{
              txt => <p className={style.hint}>{txt}</p>
            }</FormattedMessage>
          </div>}
          {/*Loading*/}
          {isLoading && !hasError &&
          <div className={style.middleWrap}>
            <div className={style.imgWrap}>
              <Loading type="circle"
                       className={style.loading}/>
            </div>
            <FormattedMessage id={loadingInl}>{
              txt => <p className={classNames(style.loading, style.bold)}>{txt}</p>
            }</FormattedMessage>
          </div>}
          {/*Successful load*/}
          {!isLoading && hasUploaded && !hasError &&
          <div className={style.middleWrap}>
            <i className={classNames(icons.symbolCheck, style.success)}/>
            <FormattedMessage id={successIntl}>{
              txt => <p className={classNames(style.success, style.bold)}>{txt}</p>
            }</FormattedMessage>
            <FormattedMessage id={changeImageIntl}>{
              txt => <p className={style.changeImage}>{txt}</p>
            }</FormattedMessage>
          </div>}
          {/*Error*/}
          {hasError && !!errorIntl && !!retryIntl &&
          <div className={style.middleWrap}>
            <i className={classNames(icons.symbolExclamationCircle, style.error)}/>
            <FormattedMessage id={errorIntl}>{
              txt => <p className={style.error}>{txt}</p>
            }</FormattedMessage>
            <FormattedMessage id={retryIntl}>{
              txt => <p className={style.retry}>{txt}</p>
            }</FormattedMessage>
          </div>}
        </div>
      </Dropzone>);
  }
}

UploadBox.propTypes = {
  isLoading: PropTypes.bool,
  hasError: PropTypes.bool,
  preview: PropTypes.string,
  fileType: PropTypes.string,
  hasUploaded: PropTypes.bool,
  loadingInl: PropTypes.string.isRequired,
  uploadIntl: PropTypes.string.isRequired,
  hintIntl: PropTypes.string,
  successIntl: PropTypes.string.isRequired,
  changeImageIntl: PropTypes.string.isRequired,
  errorIntl: PropTypes.string,
  retryIntl: PropTypes.string,
  handleChangeFile: PropTypes.func.isRequired,
  handleRejectedFile: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/order/components/UploadBox/UploadBox.jsx